// extracted by mini-css-extract-plugin
module.exports = {"container":"cart-status_container__vw2NI","itemCount":"cart-status_itemCount__DrcW4","price":"cart-status_price__E0nS9","divider":"cart-status_divider__40Qjm"};